<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imageUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imageUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='企业背景图'>
              <va-file-upload
                type='single'
                v-model='insertData.image'
                @input="uploadEnterpriseToOneImage"
              />
            </va-card>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.title"
              label="岗位"
              removable
              :messages="message"
              :error="!!error.titleErrors.length"
              :error-messages="error.titleErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.projectDuration"
              label="项目周期"
              removable
              :messages="message"
              :error="!!error.projectDurationErrors.length"
              :error-messages="error.projectDurationErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.description"
              placeholder="描述"
            ></vue-trix>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../api/upload'
import enterpriseToOneApi from '../../api/enterpriseToOne'
import { copyObject } from '../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        image: [],
        imageUrl: '',
        title: '',
        projectDuration: '',
        description: '',
        sortNum: null,
      },
      message: ['Required field'],
      error: {
        titleErrors: [],
        projectDurationErrors: [],
        descriptionErrors: [],
        sortNumErrors: [],
      },
      title: '新增名企一对一',
      showId: false,
      submitButtonStatus: true,
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑名企一对一'
      // 通过id获取详情
      enterpriseToOneApi.getEnterpriseToOne(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.titleErrors.length &&
          !this.error.projectDurationErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.sortNumErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imageUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        serviceId: this.insertData.serviceId,
        imageUrl: this.insertData.imageUrl,
        title: this.insertData.title,
        projectDuration: this.insertData.projectDuration,
        description: this.insertData.description,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        enterpriseToOneApi.updateEnterpriseToOne(data.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'enterpriseToOne' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        enterpriseToOneApi.saveEnterpriseToOne(data).then(response => {
          this.$router.push({ name: 'enterpriseToOne' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      }
    },
    clickCancel () {

    },
    uploadEnterpriseToOneImage () {
      if (this.insertData.image.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.image[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.imageUrl = response.url
      })
    },
    checkField () {
      this.error.titleErrors = this.insertData.title ? [] : ['name is required']
      this.error.projectDurationErrors = this.insertData.projectDuration ? [] : ['projectDuration is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>
<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
